// TODO(https://github.com/combinaut/sparkle/issues/32464): delete once legacy emitters dispatch native events.
window.Sparkle ??= {};
const BRIDGE = Symbol.for("sparkle.analytics.legacy-bridge");

if (!window.Sparkle[BRIDGE]) {
  window.Sparkle[BRIDGE] = true;

  for (const type of [
    "pageview",
    "search",
    "search-select",
    "autocomplete",
    "autocomplete-select",
    "message-shown",
    "decision-tree-step",
    "embed:play",
    "embed:pause",
    "embed:ended",
    "scroll-depth",
  ]) {
    function forwardNamespacedEvent(event, ...args) {
      if (event.namespace === "sparkle") {
        const target = event.target?.dispatchEvent ? event.target : document;
        target.dispatchEvent(
          new CustomEvent(`${type}.sparkle`, { bubbles: true, composed: true, detail: { ...event.detail, args } }),
        );
      }
    }

    jQuery(document).on(`${type}.sparkle`, forwardNamespacedEvent);
  }

  const clicks = new WeakSet();
  window.Sparkle[Symbol.for("sparkle.analytics.forwarded-clicks")] = clicks;

  function forwardClick(event) {
    if (!event.isTrigger) {
      return;
    }

    let source = event;

    while (source.originalEvent && source.originalEvent !== source) {
      source = source.originalEvent;
    }

    const link = source.composedPath?.().find((node) => node.matches?.("a")) || event.target?.closest?.("a");

    if (!link) {
      return;
    }

    clicks.add(event.target);

    function forgetForwardedClick() {
      clicks.delete(event.target);
    }

    queueMicrotask(forgetForwardedClick);
    document.dispatchEvent(new CustomEvent("sparkle:legacy-click", { detail: { link, eventDetail: event.detail } }));
  }

  function forwardPjaxSuccess(event, ...args) {
    document.dispatchEvent(new CustomEvent("sparkle:pjax-success", { detail: { ...event.detail, args } }));
  }

  jQuery(document).on("click", forwardClick);
  jQuery(document).on("pjax:success", forwardPjaxSuccess);
}
